import { render } from "./package-carousel.vue?vue&type=template&id=51d8311e&scoped=true"
import script from "./package-carousel.vue?vue&type=script&lang=js"
export * from "./package-carousel.vue?vue&type=script&lang=js"

import "./package-carousel.vue?vue&type=style&index=0&id=51d8311e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d8311e"]])

export default __exports__